import React from 'react';
import {
  Box,
  Chip,
  IconButton,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

type Props = {
  primaryLabel: string;
  badge?: string;
  checked: boolean;
  onToggle: () => void;
  disabled?: boolean;
  loading?: boolean;
  chipColor?: 'primary' | 'secondary';
  activeChipLabel?: string;
  subtitleLines?: string[];
  secondaryActions?: React.ReactNode;
};

/** Linha reutilizável com Switch — base visual do Monitorar agências (padrão PA). */
export function SelectableListItem({
  primaryLabel,
  badge,
  checked,
  onToggle,
  disabled,
  loading,
  chipColor = 'primary',
  activeChipLabel = 'Ativa',
  subtitleLines = [],
  secondaryActions,
}: Props) {
  return (
    <ListItem
      sx={{
        py: 1.25,
        '&:hover': { bgcolor: 'action.hover' },
        transition: 'background-color 0.2s',
      }}
    >
      <ListItemText
        primary={
          <Box display="flex" alignItems="center" gap={1}>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#303030' }}>{primaryLabel}</Typography>
            {badge && (
              <Chip label={badge} size="small" color={chipColor} variant="outlined" />
            )}
            {checked && (
              <Chip label={activeChipLabel} size="small" color="success" icon={<CheckCircle />} />
            )}
          </Box>
        }
        secondary={
          subtitleLines.length > 0 ? (
            <Box sx={{ mt: 0.5 }}>
              {subtitleLines.map((line) => (
                <Typography key={line} sx={{ fontSize: 12, color: '#808080' }}>
                  {line}
                </Typography>
              ))}
            </Box>
          ) : null
        }
      />
      <ListItemSecondaryAction>
        <Box display="flex" alignItems="center" gap={1}>
          {secondaryActions}
          <Tooltip title={checked ? 'Desativar' : 'Ativar'}>
            <Switch
              edge="end"
              checked={checked}
              onChange={onToggle}
              disabled={disabled || loading}
              color="success"
            />
          </Tooltip>
        </Box>
      </ListItemSecondaryAction>
    </ListItem>
  );
}
